<template>
    <div id="lm-form-builder-ui" class="wrapper-content w-100">
      <h1>FormBuilderUi</h1>
      <div class="row position-relative">
        <LmComponentLoading v-if="isLoading" fixed />
        <div class="col-12 col-md-3">
            <router-link to="/FormBuilderUi/" class="d-block">Nuevo</router-link>
            <router-link :to="`/FormBuilderUi/edit/${currentID}`" class="d-block mt-2">Editar {{currentID}}</router-link>
            <router-link :to="`/FormBuilderUi/preview/${currentID}`" class="d-block mt-2">Preview {{currentID}}</router-link>
        </div>
        <div class="col-12 mt-3">
          <b-form-group label="Modos">
            <b-form-radio-group
              id="btn-modos"
              v-model="modes.selected"
              :options="modes.options"
              buttons
              button-variant="primary"
              @change="modes.editView = $event === 'edit'"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6" v-show="modes.editView">
          <LmForm ref="lmFormRef" id="form-builder-ui-form">
            <LmTextInput
              class="col-12"
              v-model="form.pageTitleData"
              :v="$v.form.pageTitleData"
              label="Titulo del formulario" />
            <LmTextInput
              class="col-12 col-md-6"
              id="input-alias"
              v-model="form.alias"
              :v="$v.form.alias"
              label="Alias" />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.apiRestForHandleAllHttpMethods"
              :v="$v.form.apiRestForHandleAllHttpMethods"
              label="Path api rest para manejar GET, POST Y UPDATE"
              />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.messageAfterPOSTorPUT"
              label="Mensage post guardado" />
            <LmTextInput
              class="col-12 col-md-6"
              v-model="form.pathToRedirectAfterPOSTorPUT"
              label="Post guardado redireccionar a este path" />
            <draggable
              class="col-12"
              v-model="form.formElements"
              @start="drag=true"
              @end="drag=false"
              >
              <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4 border border-primary">
                <header
                  class="d-flex justify-content-between align-items-center bg-primary text-white pr-3 pl-3"
                  :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                  <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                  <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center">{{title(form.formElements[index])}}</h4>
                  <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div>
                    <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" />
                    <font-awesome-icon v-if="form.formElements.length > 1" class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" />
                  </div>
                </header>
                <b-collapse
                  accordion="my-accordion"
                  :id="`collapse-${index}`"
                  visible
                  class="p-4"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="form.formElements[index].componentName"
                    :options="generator.selectorElementTypeOptions"
                    label="Seleccione el tipo de elemento"
                    @input="selectorElementForm($event, index)"
                  />
                  <component
                    :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                    :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                    :componentData="form.formElements[index]"
                    :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                    :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                    :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                    :options="lmSuperPowerSelectV2BuilderUiOptions"
                    @input="inputHandler($event, index)"
                    @validations-changes="validationsChangesHandler"
                  />
                </b-collapse>
              </div>
            </draggable>
            <p v-if="$v.$error && !$v.form.formElements.required" class="invalid-feedback d-block">El formulario debe tener al menos un elemento.</p>
            <div class="col-12">
              <LmButton
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addFormElement(form.formElements.length)"
                value="Agregar un campo al formulario"
              />
            </div>
            <div class="col-12" v-if="false">
              <div class="mt-2 border border-warning">
                <header
                  class="d-flex justify-content-between align-items-center bg-warning text-white pr-3 pl-3">
                  <h4 v-b-toggle="`conditionals`" class="flex-grow-1 text-center">
                    {{$t('Conditional')}}
                    <font-awesome-icon class="ml-1" icon="random" />
                  </h4>
                </header>
                <b-collapse
                  accordion="conditionals"
                  id="conditionals"
                  visible
                  class="p-4"
                  >
                  <div v-for="(conditional, index) in form.conditionals" :key="conditional.id">
                    <div class="row align-items-center">
                      <p class="m-0 col-1">{{$t('If')}}</p>
                      <LmSelect
                        class="col-3"
                        id="select-left-value-to-compare-select"
                        :options="leftValueToCompareOptions"
                        @input="leftValueToCompareOptionsOnInput($event, index)"
                        :value="conditional.leftValueToCompare"
                      />
                      <p class="m-0 col-1">{{$t('Is')}}</p>
                      <LmSelect
                        class="col-3"
                        id="select-compare"
                        :options="toCompareOptions"
                        @input="toCompareOptionsOnInput($event, index)"
                        :value="conditional.comparation"
                      />
                      <p class="m-0 col-1">{{$t('To')}}</p>
                      <LmTextInput
                        class="col-3 mt-4"
                        @input="rightValueToCompareOptionsOnInput($event, index)"
                        :value="conditional.rightValueToCompare"
                        />
                    </div>
                    <div class="row">
                      <div class="col-md-5 col-12 mb-5">
                        <p>
                          {{$t('show_elements')}}
                        </p>
                        <draggable class="list-group h-100" :list="conditional.actions.formElementsToShow" group="form-elements">
                          <div
                            class="list-group-item"
                            v-for="formElement in conditional.actions.formElementsToShow"
                            :key="formElement.id"
                          >
                            <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                            {{ getUiReferenceForShowOrHide(formElement) }}
                            <font-awesome-icon class="float-right" icon="eye" size="sm" />
                          </div>
                        </draggable>
                      </div>
                      <div class="col-md-2 col-12 text-center">
                        <p>Y</p>
                      </div>
                      <div class="col-md-5 col-12">
                        <p>
                          {{$t('hide_elements')}}
                        </p>
                        <draggable class="list-group h-100" :list="conditional.actions.formElementsToHide" group="form-elements">
                          <div
                            class="list-group-item"
                            v-for="(formElement) in conditional.actions.formElementsToHide"
                            :key="formElement.id"
                          >
                            <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                            {{ getUiReferenceForShowOrHide(formElement) }}
                            <font-awesome-icon class="float-right" icon="eye-slash" size="sm" />
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <LmButton
                        class="mt-4"
                        buttonClass="btn-warning"
                        type="button"
                        lmButtonRootWrapperClass="d-inline-block"
                        lmButtonWrapperClass="col"
                        @click.native="addConditional({
                          id: generateId(),
                          comparation:'',
                          leftValueToCompare:'',
                          rightValueToCompare:'',
                          actions: {
                            formElementsToShow: [],
                            formElementsToHide: []
                          }
                        })"
                        :value="$t('add_conditional')"
                      />
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </LmForm>
        </div>
        <div class="col-12" :class="{ 'col-md-6': modes.editView }">
          <LmFormBuilder
            :getComponents="form"
            :isOnPreviewMode="modes.editView"
            @openEditFormElement="openEditFormElement"
          />
        </div>
        <div class="col-12 mt-4" v-show="modes.editView">
          <LmButton
            id="submit-button"
            type="button"
            :value="$t('Save')"
            buttonClass="btn-primary"
            lmButtonRootWrapperClass="d-inline-block"
            @click.native="submit"/>
        </div>
      </div>
    </div>
</template>

<script>
import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmSelect from '@/components/form/elements/LmSelect'
import draggable from 'vuedraggable'
import LmFormBuilder from '@/components/LmFormBuilder'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'

import commonsApi from '@/api/commons'
import { required } from 'vuelidate/lib/validators'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  data () {
    return {
      elementIdConditional: '',
      toCompareOptions: {
        disabledOption: this.$t('Element'),
        content: [
          { value: '===', text: '===' },
          { value: '!==', text: '!==' },
          { value: '>', text: '>' },
          { value: '<', text: '<' }
        ]
      },
      isLoading: false,
      lmSuperPowerSelectV2BuilderUiOptions: [
        { id: 1, name: 'oficinas/secretarias/' },
        { id: 2, name: 'oficinas' },
        { id: 3, name: 'delegaciones/crm/dev/api/EstadoCivil' },
        { id: 4, name: 'delegaciones/crm/dev/api/TipoEvento' },
        { id: 5, name: 'delegaciones/crm/dev/api/Origen' },
        { id: 6, name: 'delegaciones/crm/dev/api/Nacionalidad' },
        { id: 7, name: 'delegaciones/crm/dev/api/Motivo' },
        { id: 8, name: 'delegaciones/crm/dev/api/SubMotivo' },
        { id: 9, name: 'delegaciones/crm/dev/api/Prioridad' },
        { id: 10, name: 'delegaciones/crm/dev/api/TipoCaso' },
        { id: 11, name: 'delegaciones/crm/dev/api/Secretaria' },
        { id: 12, name: 'delegaciones/crm/dev/api/Genero' },
        { id: 13, name: 'delegaciones/crm/dev/api/OrigenEvento' },
        { id: 14, name: 'delegaciones/crm/dev/api/TipoDocumento' }
      ],
      currentID: this.$route?.params?.id || '',
      modes: {
        selected: 'edit',
        options: [
          { text: '✏ Editar', value: 'edit' },
          { text: 'Preview 🥽', value: 'preview' }
        ],
        editView: true
      },
      generator: {
        selectorElementTypeOptions: {
          disabledOption: 'Seleccione una opción',
          content: [
            { value: 'LmTextInput', text: '🔤  Text' },
            { value: 'LmNumberInput', text: '🔢  Number' },
            { value: 'LmEmailInput', text: '📧  Email' },
            { value: 'LmTextArea', text: '📝  Text Area' },
            { value: 'LmFormSeparator', text: '➖  Separador' },
            { value: 'LmFormEmptySpace', text: '↔ Espacio vacio' },
            { value: 'LmFormSubtitles', text: '📰  Subtítulo' },
            { value: 'LmSelect', text: '👆  Select' },
            { value: 'LmSuperPowerSelectV2', text: '💪  Super power select' },
            { value: 'LmButton', text: '🔲 Botón' },
            { value: 'LmDate', text: '📆 Fecha' },
            { value: 'LmDateTime', text: '📆 🕑 Fecha y hora' },
            { value: 'LmEditor', text: '⌨ Editor' },
            { value: 'LmLeaFletMap', text: '🗺 Mapa' },
            { value: 'LmHtmlContent', text: '👨‍💻 Contenido Html' },
            { value: 'LmPassword', text: '🔑 Password' },
            { value: 'LmPortalTarget', text: '🚪 Portal' },
            { value: 'LmColorPicker', text: '🎨 Selector de Color' },
            { value: 'LmComment', text: '🗣 Comentario para el desarrollador' }
          ]
        }
      },
      form: {
        alias: '',
        pageTitleData: '',
        messageAfterPOSTorPUT: '',
        pathToRedirectAfterPOSTorPUT: '',
        apiRestForHandleAllHttpMethods: '',
        validations: {},
        formElements: [],
        conditionals: []
      },
      initialForm: {},
      initialEditFormSerialized: {}
    }
  },
  validations: {
    form: {
      pageTitleData: {
        required
      },
      alias: {
        required
      },
      apiRestForHandleAllHttpMethods: {
        required
      },
      formElements: {
        required
      }
    }
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldRenderConditionalSection () {
      return this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).length
    },
    previewView () {
      return !this.modes.editView
    },
    leftValueToCompareOptions () {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmButton,
    LmSelect,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmFormBuilder,
    LmCommentBuilderUi
  },
  methods: {
    setInitialFormElementsVisibilityOnConditionals () {
      this.form.conditionals.forEach((e, i) => {
        this.form.conditionals[i].actions.formElementsToShow = this.form.formElements.filter(formElement => {
          if (this.form.conditionals[i].actions.formElementsToHide.findIndex(e => e.id === formElement.id) === -1) {
            return e
          }
        })
        this.form.conditionals[i].actions.formElementsToHide = this.form.formElements.filter(formElement => {
          if (this.form.conditionals[i].actions.formElementsToShow.findIndex(e => e.id === formElement.id) === -1) {
            return e
          }
        })
      })
    },
    generateId () {
      return Date.now() + Math.random()
    },
    addConditional (conditional) {
      this.form.conditionals.push(conditional)
      this.setInitialFormElementsVisibilityOnConditionals()
    },
    getUiReferenceForShowOrHide (formElement) {
      return formElement?.componentProps?.label || formElement?.componentProps?.text || formElement.componentName
    },
    rightValueToCompareOptionsOnInput (value, conditionalIndex) {
      this.form.conditionals[conditionalIndex].rightValueToCompare = value
    },
    toCompareOptionsOnInput (value, conditionalIndex) {
      this.form.conditionals[conditionalIndex].comparation = value
    },
    leftValueToCompareOptionsOnInput (value, conditionalIndex) {
      this.form.conditionals[conditionalIndex].leftValueToCompare = value
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    buildOptionsChildOf (formObjectToSendToServerProperty) {
      const allSuperPowers = this.form.formElements.filter(e => e.componentName === 'LmSuperPowerSelectV2' && e.formObjectToSendToServerProperty !== formObjectToSendToServerProperty && e.componentProps.urlPathFromGetOptions)
      const content = allSuperPowers.map(e => ({ value: e?.formObjectToSendToServerProperty, text: e?.componentProps?.label }))
      content.unshift({ value: null, text: 'Ninguno' })
      return { content }
    },
    buildSameAsOptions (formElements) {
      const options = [{ value: false, text: 'Ninguno' }]
      for (const formElement in formElements) {
        const formObjectToSendToServerProperty = formElements[formElement].formObjectToSendToServerProperty
        if (formObjectToSendToServerProperty) {
          options.push(
            {
              id: formElements[formElement].id,
              value: formObjectToSendToServerProperty,
              text: formObjectToSendToServerProperty,
              label: formElements[formElement].componentProps.label
            }
          )
        }
      }
      return options
    },
    getValidation (validatedField) {
      if (!this.form.validations) {
        this.form.validations = {}
      }
      return this.form.validations[validatedField]
    },
    whatComponentBuilderUse (componentName) {
      let builderComponentToReturn = ''
      switch (componentName) {
        case 'LmTextInput':
        case 'LmNumberInput':
        case 'LmTextArea':
        case 'LmEditor':
        case 'LmPassword':
          builderComponentToReturn = 'LmTextNumberEditorTextAreaPasswordBuilderUi'
          break
        case 'LmPortalTarget':
          builderComponentToReturn = 'LmFormPortalBuilderUi'
          break
        default:
          builderComponentToReturn = componentName + 'BuilderUi'
      }
      return builderComponentToReturn
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'formbuilder',
          id: this.$route.params.id,
          paramsMode: true
        })
        this.initialEditFormSerialized = JSON.stringify(this.form)
      } else {
        this.form = JSON.parse(this.initialForm)
        this.$refs.lmFormRef.showLoading()
        setTimeout(() => {
          this.$v.$reset()
          this.$refs.lmFormRef.hideLoading()
        }, 350)
      }
    },
    async submit () {
      await this.$refs.lmFormRef.validationForm(this.$v)
      try {
        this.isLoading = true
        this.form.messageAfterPOSTorPUT = this.form.messageAfterPOSTorPUT || 'Guardada'
        this.form.pathToRedirectAfterPOSTorPUT = this.form.pathToRedirectAfterPOSTorPUT || '/'
        if (this.isOnEditMode) {
          const response = await commonsApi.axiosPutWrapper(`formbuilder/${this.$route.params.id}`, this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/FormBuilderUi/preview/${this.currentID}`, 'Puedes ver el formulario aquí', 'Se guardó exitosamente')
        } else {
          const response = await commonsApi.axiosPostWrapper('formbuilder/create', this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/FormBuilderUi/preview/${this.currentID}`, 'Puedes ver el  formulario aquí', 'Se guardó exitosamente')
        }
      } finally {
        this.isLoading = false
        this.$router.push('/listFormBuilder')
      }
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.generator.selectorElementTypeOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    },
    selectorElementForm (componentName, elementIndex) {
      let formElement = {}
      const elementWhereUserEnterDataToSendToServer = {
        id: this.generateId(),
        class: componentName === 'LmTextArea' || componentName === 'LmEditor' ? 'col-12 col-md-12' : 'col-12 col-md-6',
        componentName,
        formObjectToSendToServerProperty: `${componentName}-${elementIndex}`
      }
      const inputComponentProps = {
        componentProps: {
          label: this.$t(componentName),
          placeholder: this.$t(componentName),
          isVisible: true
        }
      }
      switch (componentName) {
        case 'LmTextInput':
        case 'LmEmailInput':
        case 'LmNumberInput':
        case 'LmTextArea':
        case 'LmEditor':
        case 'LmPassword':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...inputComponentProps
          }
          break
        case 'LmSelect':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              placeholder: componentName,
              returnObjectIdName: true,
              options: {
                disabledOption: 'Seleccione una opción',
                content: [
                  { id: 1, name: 'Yo soy el texto que se ve en el select' }
                ]
              }
            }
          }
          break
        case 'LmSuperPowerSelectV2':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            childrenOf: null,
            optionsChildOf: { content: [] },
            componentProps: {
              options: [
                { id: 1, name: 'Primer' }
              ],
              multiple: false,
              label: this.$t(componentName),
              urlPathFromGetOptions: ''
            }
          }
          break
        case 'LmDate':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              placeholder: componentName,
              config: {
                dateFormat: 'Y-m-d H:i',
                locale: 'Spanish',
                allowInput: true,
                minDate: 'today'
              }
            }
          }
          break
        case 'LmDateTime':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              placeholder: componentName,
              config: {
                dateFormat: 'Y-m-d H:i',
                locale: 'Spanish',
                enableTime: true
              }
            }
          }
          break
        case 'LmLeaFletMap':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            class: 'col-12 col-md-12',
            componentProps: {
              label: this.$t(componentName),
              placeholder: componentName,
              centerMapCoordinate: [-34.5111791, -58.49028010000001],
              zoom: 16,
              tile: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
              height: '400px'
            }
          }
          break
        case 'LmFormSubtitles':
          formElement = {
            id: this.generateId(),
            class: 'col-12 mt-3',
            componentName,
            componentProps: {
              text: 'Otro subtítulo'
            }
          }
          break
        case 'LmComment':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            class: 'col-12',
            componentProps: {
              comment: 'Este es mi comentario'
            }
          }
          break
        case 'LmPortalTarget':
          formElement = {
            class: 'col-12 col-md-6',
            componentName: 'LmPortalTarget',
            componentProps: {
              name: '',
              slim: true
            }
          }
          break
        case 'LmFormEmptySpace':
          formElement = {
            class: 'col-12 col-md-6',
            componentName
          }
          break
        case 'LmHtmlContent':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              html: '<p>Su contenido</p>'
            }
          }
          break
        case 'LmFormSeparator':
          formElement = {
            id: this.generateId(),
            class: 'col-12 mt-3',
            componentName
          }
          break
        case 'LmColorPicker':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              defaultValue: ''
            }
          }
          break
        case 'LmButton':
          formElement = {
            id: this.generateId(),
            class: 'col-auto',
            componentName,
            componentProps: {
              type: 'submit',
              value: this.$t('Save'),
              buttonClass: 'btn-primary'
            },
            actions: {
              click: {
                type: 'submit',
                arguments: {
                  path: ''
                }
              }
            }
          }
          break
      }
      this.form.formElements.splice(elementIndex, 1, formElement)
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    removeFormElement (elementIndex) {
      delete this.form.validations[this.form.formElements[elementIndex].formObjectToSendToServerProperty]
      this.form.formElements.splice(elementIndex, 1)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    },
    'form.formElements': {
      deep: true,
      handler: function () {
        this.setInitialFormElementsVisibilityOnConditionals()
      }
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  },
  beforeDestroy () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  #form-builder-ui-form
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    margin-right: -15px
    margin-left: -15px
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
#lm-form-builder-ui
  .bars
    &:hover
      cursor: grab
::v-deep
  #LmFormBuilder
    padding: 0
</style>
